<template>
    <u-btn-hamburger-basic @click="$emit('click')"><slot /></u-btn-hamburger-basic>
</template>

<script>
import UBtnHamburgerBasic from "@/components/publish/styles/buttons/u-btn-hamburger-basic.vue";

export default {
    props: {},
    components: {
        UBtnHamburgerBasic,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
